export const SettingsCopilotTrialTestimony = (): JSX.Element => {
  // TODO: Implement AX-822
  return <div>Add testimony content here</div>;
};
